import { useQuery } from "@tanstack/react-query";
import type { Brand } from "@/marketing/models/brand";
import { BRAND_QUERIES } from "@/marketing/infrastructure/influencer/brand/utils/queries";

export function useBrandLookup(): (brandId: string) => Brand | undefined {
  const { data: brandList = [] } = useQuery(BRAND_QUERIES.list({ limit: 100 }));

  const brandMap = new Map<string, Brand>(
    brandList.map((b) => [b.brandId, b]),
  );

  return (brandId: string) => brandMap.get(brandId);
}
